export const ShopPlaces = [
    {value: "MAIN", label: "Főhely"},
    {value: "FIRST_FLOOR", label: "Emelet"},
    {value: "TERRACE", label: "Terasz"},
    {value: "GARDEN", label: "Kert"},
];

export default (ShopPlaces);